export const ROWS = 6;
export const COLS = 7;
export const WIN_LENGTH = 4;
export const EMPTY_CELL = null;

export const FOUR_IN_A_ROW_PACKAGE_BOT_MAX_DIFFICULTY_01 = 0.1;
